const LobbyType = {
    WELCOME: 0,
    GAME: 1,
    SUMMARY: 2,
    END: 3

}

export default LobbyType;
